@if (isAdding()) {
  <div class="flex flex-col gap-3 min-w-72 md:min-w-85 shrink-0 border-2 border-secondary border-dashed p-3 md:p-5 bg-primary">
    <input 
      type="text" 
      placeholder="Column title" 
      class="w-full p-2 md:p-3 border-2 border-secondary rounded-sm text-base md:text-lg"
      [(ngModel)]="columnTitle"
      (keydown.enter)="handleAddColumn()"
      (keydown.escape)="cancelAdd()"
      autofocus
    />
    <div class="flex items-center gap-2 md:gap-3">
      <button
        class="w-full bg-accent border-2 border-secondary rounded-sm shadow-[3px_3px_0_0_var(--color-secondary)] py-2 text-base md:text-lg hover:translate-x-0.5 hover:translate-y-0.5 hover:shadow-[2px_2px_0_0_var(--color-secondary)] transition-all cursor-pointer"
        (click)="handleAddColumn()"
      >
        Add Column
      </button>
      <div 
        class="rounded-full w-10 h-10 md:w-11 md:h-10 bg-scarlet-rush flex items-center justify-center cursor-pointer shrink-0" 
        (click)="cancelAdd()"
      >
        <ng-icon name="heroXMark" size="1.25rem" class="md:text-2xl" color="white"></ng-icon>
      </div>
    </div>
  </div>
} @else {
  <button
    class="flex items-center justify-center w-64 md:w-75 max-h-[80vh] bg-primary border-2 border-secondary border-dashed hover:bg-sky-mint cursor-pointer transition-colors shrink-0 h-full"
    (click)="isAdding.set(true)"
  >
    <ng-icon name="heroPlus" size="2rem" class="md:text-5xl"></ng-icon>
  </button>
}